import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CryptoJsService } from '../services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class VendorRegGuard implements CanActivate {

  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isNewRegLogin = loginDetails.get('isNewRegLogin') ? loginDetails.get('isNewRegLogin') : null;

    if (isNewRegLogin == '1') {
      return true;
    } else {
      this.router.navigate(['/vendor-registration-login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}

